import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Tenants from "@/pages/Tenants";
import TenantDetail from "@/pages/TenantDetail";
import Banks from "@/pages/Banks";
import Transactions from "@/pages/Transactions";
import Settings from "@/pages/Settings";
import MonthlyReport from "@/pages/MonthlyReport";
import Leases from "@/pages/Leases";
import EtatsDesLieux from "@/pages/EtatsDesLieux";
import ChargesRegulation from "@/pages/ChargesRegulation";
import Charges from "@/pages/Charges";
import Layout from "@/components/Layout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-background"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-navy-900"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-background"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-navy-900"></div></div>;
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="tenants" element={<Tenants />} />
            <Route path="tenants/:id" element={<TenantDetail />} />
            <Route path="banks" element={<Banks />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="monthly-report" element={<MonthlyReport />} />
            <Route path="settings" element={<Settings />} />
            <Route path="leases" element={<Leases />} />
            <Route path="etats-des-lieux" element={<EtatsDesLieux />} />
            <Route path="charges-regulation" element={<ChargesRegulation />} />
            <Route path="charges" element={<Charges />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
